var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "wrapper-landing" },
    [
      _vm._l(_vm.photos, function (photo) {
        return _c("div", { key: photo.id, staticClass: "media" }, [
          _c(
            "div",
            { staticClass: "layer", attrs: { id: "layer-" + photo.id } },
            [
              _c(
                "router-link",
                {
                  staticClass: "photo-link",
                  attrs: {
                    to: { name: `${photo.formUrl ? photo.formUrl : null}` },
                    exact: "",
                  },
                },
                [
                  _c("p", { staticClass: "photo-title" }, [
                    _vm._v(_vm._s(photo.title)),
                  ]),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [
            _c("img", { attrs: { src: _vm.thumbUrl(photo.filename) } }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "media-item-footer" },
              [
                photo.formUrl
                  ? _c(
                      "router-link",
                      {
                        attrs: {
                          to: {
                            name: `${photo.formUrl ? photo.formUrl : null}`,
                          },
                          exact: "",
                        },
                      },
                      [
                        _vm._v(
                          "\n                    Submit →\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("span", [_vm._v("Closing Date: " + _vm._s(photo.date))]),
              ],
              1
            ),
          ]),
        ])
      }),
      _vm._v(" "),
      _vm._m(0),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "circles-media" }, [
      _c("div", { staticClass: "media" }, [
        _c("div", { staticClass: "layer-visible" }, [
          _c("p", [
            _vm._v("Prize Designs "),
            _c("br"),
            _vm._v(" for Modern "),
            _c("br"),
            _vm._v(" Furniture and "),
            _c("br"),
            _vm._v(" Lighting"),
          ]),
        ]),
        _vm._v(" "),
        _c("div", [
          _c("img", {
            staticClass: "circle-image",
            attrs: { src: "/images/thumb6a.png" },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "media-item-footer" }, [
            _c(
              "a",
              {
                staticStyle: {
                  width: "100%",
                  "text-align": "center",
                  cursor: "pointer",
                },
                attrs: { href: "prize-designs-for-modern-furniture-lighting" },
              },
              [
                _vm._v(
                  "\n                        Submit →\n                    "
                ),
              ]
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "media",
          staticStyle: { "margin-right": "30px", cursor: "pointer" },
        },
        [
          _c("div", { staticClass: "layer-visible" }, [
            _c("p", [
              _vm._v("Future "),
              _c("br"),
              _vm._v(" House Award - "),
              _c("br"),
              _vm._v(" International "),
              _c("br"),
              _vm._v(" Residential"),
              _c("br"),
              _vm._v(" Awards"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c("img", {
              staticClass: "circle-image",
              attrs: { src: "/images/thumb6b.png" },
            }),
            _vm._v(" "),
            _c("div", { staticClass: "media-item-footer" }, [
              _c(
                "a",
                {
                  staticStyle: { width: "100%", "text-align": "center" },
                  attrs: { href: "future-house-awards" },
                },
                [
                  _vm._v(
                    "\n                        Submit →\n                    "
                  ),
                ]
              ),
            ]),
          ]),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }